import React from 'react'
import styled from 'styled-components';
import ButtonTC from '../../../../components/button-tc/button-tc';
import { ArrowIosForward } from '@styled-icons/evaicons-solid'
import { device } from '../../../../config/theme/breakpoints';

const ContainerDestiny = styled.div<{ image: string }>`
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 250px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 40px 0 40px 0;
    margin-top: 5px;
    margin-bottom: 5px;
    width: 100%;
    cursor: pointer;
    background-size: 100% 100%;
    transition: 1s;

    :after{
        content: '';
        background: #0000005c;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 40px 0 40px 0;
        transition: .2s;
    }

    :hover {
        background-size: 110% 110%;

        :after{
            background: #00000080;
        }
    }

    @media ${device.tablet}{
        width: 46%;
    }
`

const HeaderItemContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    > h2{
        color: white;
        font-weight: bold;
        margin: 2px 15px 5px 0;
    }
    
    > h6{
        color: white;
        font-weight: 100;
        margin: 8px 15px 0 0;
    }
`

const BodyDestiny = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
`

const ContainerTour = styled.div`
    background: ${p => p.theme.palette.primary.main};
    width: fit-content;
    border-radius: 60px 0 0 15px;
    color: white;
    display: flex;
    justify-content: right;
    align-items: center;
    padding-right: 15px;
    padding-left: 40px;
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 13px;
`
const BodyItemContainer = styled.div`
    color: white;
    text-align: left;
    align-self: flex-start;
    padding-left: 20px;

    > h2, p{
        margin: 0;
    }

    > h2{
        font-weight: 500;
        margin-top: 10px
    }

    > p{
        font-style: italic;
        margin-bottom: 20px;
        font-weight: lighter;
    }
`

interface IOwnProps{
    tour?: string;
    title?: string;
    image: string;
    subTitle?: string;
    price?: string;
    onClick: () => void
}
const ItemDestiny: React.FunctionComponent<IOwnProps> = ({
    tour,
    title,
    image,
    subTitle,
    price,
    onClick
}) => {
  return (
    <ContainerDestiny image={image} onClick={onClick}>
        <BodyDestiny>
            <HeaderItemContainer>
                <ContainerTour>{tour}</ContainerTour>
                <h6>DESDE</h6>
                <h2>S/ {price}</h2>
            </HeaderItemContainer>
            <BodyItemContainer>
                <h2>{title}</h2>
                <p>{subTitle}</p>
                <ButtonTC
                    text='Ver destinos ahora'
                    icon={<ArrowIosForward />}
                    buttonStyle='secondary'
                />
            </BodyItemContainer>
        </BodyDestiny>
    </ContainerDestiny>
  )
}

export default ItemDestiny